<app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>

<main id="main-content" class="container">
    <div class="row">
        <div class="col-12 mb-3">
            <div class="col-md-4">
                <select id="provincia" class="form-select" [(ngModel)]="yearSelected">
                    @for (year of years; track year) {
                    <option value="{{year}}">{{year}}</option>
                    }
                </select>
            </div>
        </div>
        <div class="col-12 mb-3 text-center">
            <div class="input-group check-plate">
                <span class="input-group-text" id="plate"><i class="bi bi-search"></i></span>
                <input type="text" class="form-control" placeholder="Introduce una matrícula" aria-label="plate"
                    aria-describedby="plate" [(ngModel)]="plate" i18n-placeholder>
                <button type="button" class="btn btn-primary" (click)="checkAccess()" i18n>COMPROBAR</button>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="error" id="error">
        <div class="col-12">
            <div class="alert alert-danger" role="alert">
                {{error}}
            </div>
        </div>
    </div>

    <div class="row" *ngIf="noAccessText" id="noAccessText">
        <div class="col-12">
            <div class="alert alert-info" role="alert">
                {{noAccessText}}
            </div>
        </div>
    </div>

    <div class="row" *ngIf="accessList && accessList.municipalities.length > 0" id="accesos">
        <div class="col-12">
            <h2 class="mt-5" i18n>Accesos permitidos limitados por municipio</h2>
            <p class="text-destacado mb-4" i18n>Cada municipio tiene un número de accesos permitidos por año natural. En
                este diagrama aparece el número de accesos que se han contabilizado y el límite hasta ser indebidos.</p>
            <div class="card">
                <div *ngFor="let muni of accessList.municipalities; index as i">
                    <div *ngIf="muni.detections.length > 0">
                        <h4>{{muni.location}} <button class="btn btn-primary btn-small btn-access" type="button"
                                data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+i"
                                aria-expanded="false" aria-controls="collapseExample" i18n>
                                Ver más
                            </button></h4>
                        <div class="progress mb-3" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" *ngIf="muni.detectionsNonRegistered < muni.detectionsPermitted">
                            <div class="progress-bar" class="bg-success" [style]="'width: ' + ((muni.detectionsNonRegistered / muni.detectionsPermitted) * 100) + '%'">{{muni.detectionsNonRegistered}} /
                                {{muni.detectionsPermitted}}</div>
                        </div>
                        <div class="progress mb-3" role="progressbar" aria-label="Danger example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" *ngIf="muni.detectionsNonRegistered >= muni.detectionsPermitted">
                            <div class="progress-bar" class="bg-danger" [style]="'width: ' + ((muni.detectionsNonRegistered / muni.detectionsPermitted) * 100) + '%'">{{muni.detectionsNonRegistered}} /
                                {{muni.detectionsPermitted}}</div>
                        </div>
                        <div class="collapse" [attr.id]="'collapse'+i">
                            <div class="card card-body mb-3">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col" i18n>Fecha de acceso</th>
                                                <th scope="col" i18n>Municipio</th>
                                                <th scope="col" i18n>Acceso Nº</th>
                                                <th scope="col" i18n>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr  *ngFor="let access of muni.detections; index as i">
                                                <td>{{access.timestamp.timestamp | date:'dd/MM/yyyy' }}</td>
                                                <td>{{muni.location}}</td>
                                                <td>{{access.detectionsVehicleMunicipalityDetection || access.number}}</td>
                                                <td><app-detection-state [state]="access.state"></app-detection-state>
                                                </td>
                                            </tr>
                                            <tr *ngIf="muni.detections.length == 0">
                                                <td colspan="4">
                                                    <span i18n>Sin accesos</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>